{
  "fr": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Changement jalon",
        "reset_columns": "Réinitialiser les colonnes"
      },
      "labels": {
        "columns": "Colonnes",
        "milestone": "Veuillez sélectionner un nouveau jalon",
        "no_results": "Aucune unité trouvée"
      }
    }
  }
}
